module.exports = __webpack_public_path__ + "img/banner3EN.3d08c957.png";